import { makeCreateAction, makeCreateRoutine } from '../../helpers/actions';
import { Ride } from '../../types/ride';

const createAction = makeCreateAction('CREDITS_HISTORY');
const createRoutine = makeCreateRoutine('CREDITS_HISTORY');

export const getCreditsHistory = createRoutine('GET_CREDITS_HISTORY', {
  request: ({ isRefreshing = false } = {}) => ({ isRefreshing }),
  success: (credits, hasNextPage) => ({ credits, hasNextPage }),
});

export const dropRide = createRoutine('DROP_RIDE', {
  request: (ride: Ride) => ({ ride }),
  fulfill: (response: any, rideId: number, timestamp: number) => ({ response, rideId, timestamp }),
});

export const closeDropResultModal = createAction('CLOSE_DROP_RESULT_MODAL', (rideId: number) => ({
  payload: { rideId },
}));

export const exitCreditsHistory = createAction('EXIT_CREDITS_HISTORY');

export const selectRide = createAction('SELECT_RIDE', (ride: Ride | null) => ({
  payload: { ride },
}));

export const actionCreators = {
  getCreditsHistory,
  exitCreditsHistory,
  dropRide,
  closeDropResultModal,
  selectRide,
} as const;
